import Alpine from 'alpinejs';
import megaMenuSubmenus from '../util/megaMenuSubmenus';
import headerScroll from '../util/headerScroll';

window.Alpine = Alpine;

export default {
  init() {
    // JavaScript to be fired on all pages
    Alpine.start();
    megaMenuSubmenus();
    headerScroll();
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
